<template>
  <div>
    <file-manager-progress />
  </div>
</template>
<script>
import fileManagerProgress from "./file-manager-progress.vue";
export default {
  components: { fileManagerProgress },
  computed: {
    uploadedFiles() {
      return this.$store.getters[`fileManager/uploadedFiles`];
    },
    downloadedFiles() {
      return this.$store.getters[`fileManager/downloadedFiles`];
    },
    isShow() {
      if (!this.uploadedFiles || !this.downloadedFiles) {
        return false;
      }

      return this.uploadedFiles.length + this.downloadedFiles.length > 0;
    },
    progressCount() {
      return this.uploadedFiles.filter((i) => i.progress != 100).length + this.downloadedFiles.filter((i) => i.progress != 100).length;
    },
    isDownloading() {
      return this.$store.getters[`fileManager/isDownloading`];
    },
    isUploading() {
      return this.$store.getters[`fileManager/isUploading`];
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnload);
  },

  watch: {
    downloadedFiles: {
      handler(v) {
        if (!v) {
          return;
        }

        v.forEach((item) => {
          if (item.status === "pending") {
            this.$store.dispatch("fileManager/download", item);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    beforeUnload(e) {
      if (!this.isUploading && !this.isDownloading) {
        return undefined;
      }
      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
  },
};
</script>
<style scoped lang="scss">
.file-manager-progress-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 0.625rem;
  border: 1px solid #d0d0d0;
  position: relative;
  transition: background-color, color, 0.3s;

  // &:hover {
  //   .folder-icon {
  //     color: #ff7c48;
  //   }
  // }

  .folder-icon {
    color: #ff7c48;
  }

  &:hover {
    background-color: #f5f7f9;
  }
}
</style>
